import React from 'react';

import './Button.scss';

interface ButtonProps {
    primary?: boolean;
    secondary?: boolean;
    tertiary?: boolean;
    accent?: boolean;
    size?: 'standard' | 'small';
    disabled?: boolean;
    handleClick?: () => void;
    children: JSX.Element;
    type?: 'submit' | 'button';
    id?: string;
}

function Button({
        primary, 
        secondary, 
        tertiary, 
        accent,
        size = 'standard', 
        disabled, 
        handleClick, 
        children, 
        type, 
        id
    }: ButtonProps){

    const themeTypeClass = primary ? 'primary' : secondary ? 'secondary' : tertiary ? 'tertiary' : accent ? 'accent' : '';
    const sizeClass = size === 'standard' ? 'size_standard' : 'size_small';

    return(
        <button 
            id={id ? id : null} 
            className={`${themeTypeClass} ${sizeClass} __Button`} 
            onClick={handleClick} 
            type={type || "button"} 
            disabled={disabled}
            >
            {children}
        </button>
    )
}

export default Button;